import { GrowthBook } from "@growthbook/growthbook-react"

import { GROWTH_BOOK_KEY, GROWTH_BOOK_URL, IS_DEVELOPMENT } from "utils/env-management"
import { Analytics } from "utils/analytics"

export const growthBook = new GrowthBook({
    apiHost: GROWTH_BOOK_URL,
    clientKey: GROWTH_BOOK_KEY,
    enableDevMode: IS_DEVELOPMENT,
    subscribeToChanges: true,
    trackingCallback: (experiment, result) => {
        Analytics.experiment_viewed({
            experimentId: experiment.key,
            variationId: result.key,
        })
    },
})
